import React, { memo } from 'react'
import tw from 'twin.macro'
import {
  CustomerCollectedDataStatus,
  CustomerCollectedDataTypeExtended,
} from 'src/constants/customer/enums'
import { Typography } from '@mui/material'
import { customerComplianceStepIcons } from 'src/constants/customer/icons'
import { customerComplianceStepTitles } from 'src/constants/customer/constants'
import { CustomerStepStatus } from 'src/components/customer/shared/CustomerStepStatus'

export interface MCStepParams {
  stepStatus: CustomerCollectedDataStatus
  stepType: CustomerCollectedDataTypeExtended
}

interface Props {
  stepStatus: CustomerCollectedDataStatus
  stepType: CustomerCollectedDataTypeExtended
  expiresSoon?: boolean
}

const MCStepHeaderComponent = ({ stepStatus, stepType, expiresSoon }: Props) => {
  return (
    <div css={tw`flex flex-row items-center justify-between`}>
      <div css={tw`flex flex-row items-center`}>
        {customerComplianceStepIcons[stepType]}
        <Typography variant="h4" css={tw`ml-2`}>
          {customerComplianceStepTitles[stepType]}
        </Typography>
      </div>
      <CustomerStepStatus status={stepStatus} expiresSoon={expiresSoon} />
    </div>
  )
}

export const MCStepHeader = memo(MCStepHeaderComponent)
